"use strict";

Shopify.theme.jsSlideshowClassic = {
	init: function init($section) {
		// Add settings from schema to current object
		Shopify.theme.jsSlideshowClassic = $.extend(
			this,
			Shopify.theme.getSectionData($section)
		); // Selectors

		var $slideshowClassicEl = $section
			.find("[data-slideshow-classic]")
			.removeClass("is-hidden");
		var $slideshowClassic = $slideshowClassicEl.flickity({
			wrapAround: true,
			adaptiveHeight: true,
			prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
			pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
			draggable: true,
			imagesLoaded: true,
			fade: this.image_transition == "fade" ? true : false,
			autoPlay: this.image_slideshow_speed * 1000,
			arrowShape: arrowShape,
		}); // Resize flickity when the slider is settled

		$slideshowClassicEl.on("settle.flickity", function () {
			$slideshowClassicEl.flickity("resize");
		});

		var FOCUSABLE_SEL =
			'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

		function updateSlideFocusState() {
			// Flickity adds aria-hidden="true" to non-selected cells
			$slideshowClassicEl.find(".flickity-slider > *").each(function () {
				var $cell = $(this);
				var hidden = $cell.attr("aria-hidden") === "true";
				var $focusables = $cell.find(FOCUSABLE_SEL);

				if (hidden) {
					// Hide from AT + keyboard
					$cell.attr("inert", ""); // modern browsers
					$focusables.each(function () {
						var $el = $(this);
						if ($el.attr("tabindex") !== "-1") $el.attr("tabindex", "-1");
						if ($el.attr("aria-hidden") !== "true")
							$el.attr("aria-hidden", "true");
					});
				} else {
					$cell.removeAttr("inert");
					$focusables.each(function () {
						var $el = $(this);
						if ($el.attr("tabindex") === "-1") $el.removeAttr("tabindex");
						if ($el.attr("aria-hidden") === "true")
							$el.removeAttr("aria-hidden");
					});
				}
			});
		}

		// Keep in sync with selection lifecycle
		$slideshowClassicEl.on(
			"ready.flickity select.flickity settle.flickity",
			updateSlideFocusState
		);
		updateSlideFocusState();
	},
	blockSelect: function blockSelect($section, blockId) {
		var $slider = $section.find("[data-image-slideshow]");
		var $sliderIndex = $("#shopify-section-" + blockId).data("slide-index");
		$slider.flickity("select", $sliderIndex, true, true);
	},
	unload: function unload($section) {},
};
